import SidebarButton from './SidebarButton';

export default function SidebarFooter({ onSettings, onLogout, isCompact = false }) {
  return (
    <div className={`space-y-2 border-t border-teal-600 pt-2 ${isCompact ? 'px-1.5' : 'px-4'}`}>
      {onSettings && (
        <SidebarButton
          icon={onSettings.icon}
          label={onSettings.label}
          onClick={onSettings.onClick}
          variant="default"
          isCompact={isCompact}
        />
      )}
      <SidebarButton
        icon={onLogout.icon}
        label={onLogout.label}
        onClick={onLogout.onClick}
        variant="danger"
        isCompact={isCompact}
      />
    </div>
  );
}
